package com.devi3east.bashbuddy.features.common.util

import kotlin.math.abs

/**
 * Formats a nullable [Long] price (stored in cents) into a USD string.
 *
 * Examples:
 *   12345 -> "$123.45"
 *   100   -> "$1.00"
 *   50    -> "$0.50"
 *   null  -> "$0.00"
 *   -1234 -> "-$12.34"
 *
 * This implementation is multiplatform-safe and does not use platform-specific
 * locale or formatting APIs.
 */
fun formatPrice(amountCents: Long?): String {
    if (amountCents == null) return "$0.00"

    val negative = amountCents < 0
    val absValue = abs(amountCents)

    val dollars = absValue / 100
    val cents = (absValue % 100).toInt()

    // Add commas manually (multiplatform safe)
    val dollarsStr = dollars.toString()
        .reversed()
        .chunked(3)
        .joinToString(",")
        .reversed()

    val centsStr = cents.toString().padStart(2, '0')
    val sign = if (negative) "-" else ""

    return "$sign$$dollarsStr.$centsStr"
}
